import { api } from "api";
import RouterErrorBox from "components/RouterErrorBox";
import type { NonIndexRouteObject } from "react-router-dom";

import EditTaskDefinitionRoute from "./EditTaskDefinitionRoute";
import NewTaskDefinitionRoute from "./NewTaskDefinitionRoute";
import TaskDefinitionsListRoute from "./TaskDefinitionsListRoute";
import TaskDefinitionsRoute from "./TaskDefinitionsRoute";
import { TaskDefinitionRoute } from "./view";

export const taskDefinitionsRoute: NonIndexRouteObject = {
  element: <TaskDefinitionsRoute />,
  errorElement: <RouterErrorBox />,
  children: [
    {
      index: true,
      loader: () => api.listTaskDefinitions(),
      element: <TaskDefinitionsListRoute />,
    },
    {
      path: "new",
      element: <NewTaskDefinitionRoute />,
      errorElement: <RouterErrorBox />,
    },
    {
      path: ":definitionId/edit",
      loader: ({ params }) => api.getTaskDefinition(params.definitionId ?? ""),
      element: <EditTaskDefinitionRoute />,
      errorElement: <RouterErrorBox />,
    },
    {
      path: ":definitionId",
      loader: ({ params }) => api.getTaskDefinition(params.definitionId ?? ""),
      element: <TaskDefinitionRoute />,
      errorElement: <RouterErrorBox />,
    },
  ],
};
